<template>
  <h1>PRICING</h1>
</template>

<script setup></script>

<style lang="scss" scoped></style>
